import { render, staticRenderFns } from "./edit-category.vue?vue&type=template&id=70439ae5&scoped=true"
import script from "./edit-category.vue?vue&type=script&lang=js"
export * from "./edit-category.vue?vue&type=script&lang=js"
import style0 from "./edit-category.vue?vue&type=style&index=0&id=70439ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70439ae5",
  null
  
)

export default component.exports